// QR sin dependencias de red: generador incluido en `src/vendor/`
// (qrcode-generator 1.4.4 de Kazuhiko Arase, licencia MIT).
// Dibuja el texto en un <canvas> con celdas nítidas para pantallas táctiles.
import qrcodeFactory from '../../../vendor/qrcode-generator-1.4.4';

export function renderQrToCanvas(canvas, text, { cellSize = 6, margin = 4, dark = '#0A1A0F', light = '#ffffff' } = {}) {
  if (!canvas) return false;
  try {
    const code = qrcodeFactory(0, 'M');
    code.addData(String(text || ''));
    code.make();
    const count = code.getModuleCount();
    const size = (count + margin * 2) * cellSize;
    const ratio = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = size * ratio;
    canvas.height = size * ratio;
    canvas.style.width = `${size}px`;
    canvas.style.height = `${size}px`;
    const context = canvas.getContext('2d');
    context.scale(ratio, ratio);
    context.fillStyle = light;
    context.fillRect(0, 0, size, size);
    context.fillStyle = dark;
    for (let row = 0; row < count; row += 1) {
      for (let col = 0; col < count; col += 1) {
        if (code.isDark(row, col)) {
          context.fillRect((col + margin) * cellSize, (row + margin) * cellSize, cellSize, cellSize);
        }
      }
    }
    return true;
  } catch {
    return false;
  }
}
